import React, { useState } from 'react'
import { filter } from 'lodash-es'

import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import Collapse from '@mui/material/Collapse'
import Divider from '@mui/material/Divider'

import Link from '../Common/Link'

import { Category } from '@/src/types/api-types'
import pushRoute from '@/lib/pushRoute'
import getRouteByBrand from '@/lib/getRouteByBrand'

type Props = {
  category: Category
  categories: Category[]
  mobile?: boolean
}

const SubSubCategory: React.FC<Props> = ({ category, categories, mobile = false }) => {
  const [open, setOpen] = useState<boolean>(false)

  const handleClick = () => {
    setOpen(!open)
  }

  const handleClickBrand = async brand => {
    return pushRoute(await getRouteByBrand(brand))
  }

  const subCategories = filter(
    categories,
    c => Number(c.parent_id) === Number(category.category_id)
  )

  if (mobile) {
    // Lien vers la destination de la categorie (ligne sans sous-menu + "Voir tout")
    const mobileCategoryLink = (label: string) =>
      /* @ts-ignore */
      category.isBrand ? (
        <ListItemText onClick={() => handleClickBrand(category)} primary={label} />
      ) : (
        <Link
          route="Catalogsearch"
          argsObject={{ query: '', featuresHash: `Catégories-${category?.category ?? ''}` }}
          className="cursor-pointer"
        >
          <ListItemText primary={label} />
        </Link>
      )

    return (
      <>
        {subCategories.length > 0 ? (
          // Tap sur toute la ligne = deplier/replier (pas de navigation, sinon le
          // drawer se ferme via routeChangeStart)
          <ListItem button onClick={handleClick}>
            <ListItemText primary={category.category} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
        ) : (
          <ListItem button>{mobileCategoryLink(category.category)}</ListItem>
        )}
        <Divider />
        <Collapse in={open} timeout="auto" unmountOnExit style={{ paddingLeft: 16 }}>
          <ListItem button>{mobileCategoryLink(t({ id: 'web_see_all' }))}</ListItem>
          <Divider />
          {subCategories.map(subCat => (
            <>
              <ListItem key={subCat.category_id} button>
                <Link
                  route="Catalogsearch"
                  argsObject={{
                    query: '',
                    featuresHash: `Catégories-${encodeURIComponent(subCat?.category ?? '')}`,
                  }}
                >
                  <ListItemText primary={subCat.category} />
                </Link>
              </ListItem>
              <Divider />
            </>
          ))}
        </Collapse>
      </>
    )
  }

  return (
    <td className="align-top p-4 font-normal text-sm">
      <div className="text-base">
        <Link 
          route="Catalogsearch" 
          argsObject={{ query: '', featuresHash: `Catégories-${category?.category ?? ''}` }}
          className="cursor-pointer text-base"
        >
          {category.category}
        </Link>
      </div>
      <div>
        {subCategories.map(subCat => (
          <div key={subCat.category_id}>
            <Link 
              route="Catalogsearch" 
              argsObject={{ query: '', featuresHash: `Catégories-${subCat?.category ?? ''}` }}
              className="cursor-pointer"
            >
              {subCat.category}
            </Link>
          </div>
        ))}
      </div>
    </td>
  )
}

export default SubSubCategory
